import React from 'react';
import {BrowserRouter, PrivateRoute, Redirect, Route, Switch} from 'react-router-dom';
import { isAuthenticated } from "./services/auth";
import Login from './pages/Login';
import Home from './pages/Home';
import Registro from './pages/Registro';
import Usuario from './pages/Usuario';
import Esqueceu from './pages/Esqueceu';
import Empresa from './pages/Empresa';
import Pessoa from './pages/Pessoa';
import Grupo from './pages/Grupo';
import GrupoServico from './pages/GrupoServico';
import Servico from './pages/Servico';
import Pagamento from './pages/Pagamento';
import Promocao from './pages/Promocao';
import Comissao from './pages/Comissao';
import Vendas from './pages/Vendas'
import pdv from './pages/pdv'
import Combo from './pages/Combo'
import Cupom from './pages/Cupom'
import Separacao from './pages/Separacao'
import Lavar from './pages/Lavar'
import Passar from './pages/Passar'
import ChatBotPedido from './pages/chatBotPedido'
import RelatorioAcompanhamentoDeVendas from './pages/Relatorio_Vendas'
import RelatorioPorRecebimentos from './pages/Relatorio_Faturamento'
import RelatorioPorServico from './pages/Relatorio_Servicos'
import RelatorioPorSeparacao from './pages/Relatorio_Separacao'
import RelatorioPorPreco from './pages/Relatorio_Precos'
import RelatorioComissao from './pages/Relatorio_Comissao';
import Content from './pages/template/Content';

export default function Routes() {

    const PrivateRoute = ({ component: Component, ...rest }) => (
        <Route
          {...rest}
          render={props =>
            isAuthenticated() ? (
              <Component {...props} />
            ) : (
              <Redirect to={{ pathname: "/", state: { from: props.location, id: props.id } }} />
            )
          }
        />
      );
    const base = 'appservice'
    return (   
        <BrowserRouter>
            <Switch>
                <Route path="/" exact component={Login} />
                <Route path="/login" exact component={Login} />
                <Route path="/registro" component={Registro} />
                <Route path="/esqueceu" component={Esqueceu} />  
                <PrivateRoute path="/cupom/:id" component={Cupom} />
               
          
                <Content>
                  <PrivateRoute path="/index" component={Home} />
                  <PrivateRoute path="/empresa" component={Empresa} />
                  <PrivateRoute path="/pessoa" component={Pessoa} />                  
                  <PrivateRoute path="/grupo" component={Grupo} />
                  <PrivateRoute path="/gruposervico" component={GrupoServico} />
                  <PrivateRoute path="/servico" component={Servico} />
                  <PrivateRoute path="/comissao" component={Comissao} />
                  <PrivateRoute path="/pagamento" component={Pagamento} />
                  <PrivateRoute path="/separacao" component={Separacao} />
                  <PrivateRoute path="/lavar" component={Lavar} />
                  <PrivateRoute path="/passar" component={Passar} />                  
                  <PrivateRoute path="/promocao" component={Promocao} />
                  <PrivateRoute path="/venda" component={Vendas} />
                  <PrivateRoute path="/pdv" component={pdv}/>
                  <PrivateRoute path="/combo" component={Combo} />
                  <PrivateRoute path="/usuario" component={Usuario} />
                  <PrivateRoute path="/chatBotPedido" component={ChatBotPedido} />
                  <PrivateRoute path="/relatoriovendas" component={RelatorioAcompanhamentoDeVendas} />
                  <PrivateRoute path="/relatoriofaturamento" component={RelatorioPorRecebimentos} />
                  <PrivateRoute path="/relatorioservico" component={RelatorioPorServico} />
                  <PrivateRoute path="/relatorioseparacao" component={RelatorioPorSeparacao} />
                  <PrivateRoute path="/relatoriopreco" component={RelatorioPorPreco} />
                  <PrivateRoute path="/relatoriocomissao" component={RelatorioComissao} />
                </Content>
                
            </Switch>
        </BrowserRouter>
    );
}